import { render, staticRenderFns } from "./membersTab.vue?vue&type=template&id=4851b958&scoped=true"
import script from "./membersTab.vue?vue&type=script&lang=js"
export * from "./membersTab.vue?vue&type=script&lang=js"
import style0 from "./membersTab.vue?vue&type=style&index=0&id=4851b958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4851b958",
  null
  
)

export default component.exports